import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=0a97c360&"
import script from "./Navigation.vue?vue&type=script&lang=coffee&"
export * from "./Navigation.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports